import type { MouseEvent } from 'react';
import {
  deferTracking,
  sendGAEvent,
  sendGALinkClickEvent,
} from '@noths/polaris-client-google-analytics';

export const trackPartnerImpression = (partnerShortcode: string) => {
  deferTracking(() =>
    sendGAEvent({
      event: 'custom_event',
      event_action: 'Impression',
      event_category: 'Seller shelf',
      event_label: 'not set',
      event_name: 'view_content',
      content_type: 'seller shelf',
      item_id: partnerShortcode,
    }),
  );
};

export const trackStoryClick = (e: MouseEvent<HTMLAnchorElement>) => {
  sendGALinkClickEvent(e, {
    event: 'custom_event_v2',
    event_name: 'select_content',
    event_details: 'link click',
    item_id: 'view full story',
    content_type: 'seller shelf',
    destination_url: e.currentTarget.getAttribute('href'),
  });
};

export const trackVisitShopClick = (e: MouseEvent<HTMLAnchorElement>, partnerShortcode: string) => {
  sendGALinkClickEvent(e, {
    event: 'custom_event',
    event_action: 'Partner storefront click',
    event_category: 'Seller shelf',
    event_label: 'visit shop CTA',
    event_name: 'select_content',
    event_details: 'visit shop button click',
    content_type: 'seller shelf',
    item_id: partnerShortcode,
    destination_url: e.currentTarget.getAttribute('href'),
  });
};
